var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2844 0.75L13.0469 7.0875H15.1469L19.8719 0.75H17.2844Z",
    fill: "#428BC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1531 0.75L10.9531 7.0875H13.0531L17.2906 0.75H15.1531Z",
    fill: "#E8E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0516 0.75L8.85156 7.0875H10.9516L15.1516 0.75H13.0516Z",
    fill: "#ED4C5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9984 23.25C16.2648 23.25 19.7234 19.7914 19.7234 15.525C19.7234 11.2586 16.2648 7.79999 11.9984 7.79999C7.73204 7.79999 4.27344 11.2586 4.27344 15.525C4.27344 19.7914 7.73204 23.25 11.9984 23.25Z",
    fill: "#FFCE31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13438 5.66248C7.94688 5.66248 7.79688 5.81248 7.79688 5.99998V9.14998C7.79688 9.33748 7.94688 9.48748 8.13438 9.48748H15.8594C16.0469 9.48748 16.1969 9.33748 16.1969 9.14998V5.99998C16.1969 5.81248 16.0469 5.66248 15.8594 5.66248H8.13438ZM15.5219 8.13748C15.5219 8.32498 15.3719 8.47498 15.1844 8.47498H8.84688C8.65938 8.47498 8.50938 8.32498 8.50938 8.13748V6.71248C8.50938 6.52498 8.65938 6.37498 8.84688 6.37498H15.1844C15.3719 6.37498 15.5219 6.52498 15.5219 6.71248V8.13748Z",
    fill: "#FFCE31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.35938 16.425C5.35938 12.225 8.58438 8.81248 12.7094 8.51248C12.5219 8.51248 12.2969 8.47498 12.1094 8.47498C8.17188 8.47498 4.98438 11.6625 4.98438 15.6375C4.98438 16.8 5.28437 17.925 5.77187 18.9C5.50937 18.1125 5.35938 17.2875 5.35938 16.425Z",
    fill: "#89664C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M14.9594 21.4875C18.4469 19.1625 19.4969 14.625 17.4719 11.1L17.8094 11.55C19.9844 14.775 19.0844 19.1625 15.8219 21.375C14.8469 22.05 13.7594 22.425 12.6719 22.5375C13.4969 22.3125 14.2469 21.975 14.9594 21.4875Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85 7.0875H10.95L6.7125 0.75H4.125L8.85 7.0875Z",
    fill: "#ED4C5C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9484 7.0875H13.0484L8.84844 0.75H6.71094L10.9484 7.0875Z",
    fill: "#E8E8E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.3391 1.79999L11.2891 3.37499L13.7641 7.08749H15.1516L15.5266 6.56249L12.3391 1.79999Z",
    fill: "#3E4347"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0516 7.0875H15.1516L10.9516 0.75H8.85156L13.0516 7.0875Z",
    fill: "#428BC1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.0469 13.2V13.575C10.4219 13.575 10.7594 13.5 11.0969 13.35V12.825C10.7969 13.05 10.4594 13.1625 10.0469 13.2ZM12.5219 10.7625H12.8594V18.8625H12.5219V10.7625ZM11.4719 21.6375V20.25H10.0469V20.625H14.2844V19.2L11.4719 21.6375Z",
    fill: "#89664C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M12.8594 18.8625H13.9094V19.2H12.8594V18.8625ZM11.4719 10.7625H12.5219V10.425H11.0969C11.0969 11.2125 10.4594 11.85 9.67188 11.85V13.2375C9.78438 13.2375 9.89688 13.2375 10.0094 13.2V12.15C10.8344 12.1875 11.4719 11.55 11.4719 10.7625ZM11.4719 19.2V13.2C11.3594 13.275 11.2469 13.3125 11.1344 13.3875V18.8625H9.70938V20.25H10.0469V19.2H11.4719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/gold-medal.cabd5ea7.svg";
export { ForwardRef as ReactComponent };